<template>
	<v-checkbox
		v-model="check.value"
		:label="check.label"
		:color="color ? color : $store.state.PointColor1"
		:class="check.class"
		:value="check.detailcode"
		on-icon="mdi-check-circle"
		off-icon="mdi-check-circle-outline"
		dense
		:error-messages="check.errorMessage"
		:hide-details="check.hideDetail"
		@click="$emit('click')"
		:disabled="disable"
		:ripple="false"
	>
	</v-checkbox>
</template>

<script>
export default {
	props: {
		check: Object,
		color: String,
		disable: Boolean,
	},
	methods: {
		changeDummy() {},
	},
}
</script>

<style lang="scss">
.sliceCheck {
	margin: -5px 0px 0px 0px !important;
	padding: 0px;
	.v-input__slot {
		align-items: end;
	}

	.v-icon.v-icon--dense {
		font-size: 25px;
	}
	.v-label {
		font-size: 16px;
	}
}
.filterCheckBox {
	// padding: 0px;
	// margin: px !important;
	.v-label {
		font-size: 14px !important;
	}
	.v-input__slot {
		align-items: start;
	}
}
</style>
